'use client'

import { Suspense } from 'react'

import ErrorPage from 'Clutch/Organisms/ErrorPage'

export default function Custom404() {
  return (
    <Suspense>
      <ErrorPage statusCode={404} />
    </Suspense>
  )
}
